/**
 * @description  Closed by entry
 */

export default Object.freeze({
  CUSTOMER: 'CUSTOMER',
  SYSTEM: 'SYSTEM',
  AGENT: 'AGENT',
  BOT: 'BOT',
})
